<template>
    <el-dialog title="选择软件" :visible.sync="dialogVisible" :close-on-click-modal="false" width="80rem">
        <div class="soft-box">
            <Table :totalSize="tableData.length" :pagination="false" :operationWidth="350" :currentPage="pages.current"
                :pageSize="pages.size" navHeight=40 ref="table" :tableData="tableData" :tableKey="tableKey">
                <template slot="operation" slot-scope="data">
                    <div class="btn-button" :class="{ 'disable-button': data.data.row.examineStatus == '2' }"
                        @click="startTask(data.data.row)">开始任务</div>
                </template>
            </Table>
        </div>
    </el-dialog>
</template>

<script>
import { openVirtual } from '@/utils/utils';
import { PushExamineRecord } from '@/api/examine';
import detectProtocol from "custom-protocol-detection";
import { getFileInfo } from '@/api/common/commonFile';
export default {
    data() {
        return {
            dialogVisible: false,
            currentTab: '',
            tableData: [],
            /**任务Id */
            taskId: '',
            /**考核类型 */
            examineType: '',
            pages: {
                current: 1,
                size: 10,
            },
            optSource: '',
            tableKey: [
                {
                    name: '软件名称',
                    value: 'softwareName'
                },
                {
                    name: '软件类型',
                    value: 'resType'
                },
                {
                    name: '',
                    value: 'operation',
                    slot: 'operation'
                },
            ]
        }
    },
    methods: {
        startTask(item) {
            if (item.examineStatus == '2') return;
            let params = {
                "examineId": this.taskId,
                "examineType": this.examineType,
                "resourceId": item.id,
                "type": 0
            };
            var url = openVirtual(item.url) + '?optSource=' + this.optSource + '&businessId=' + this.taskId + '-' + item.id;
            if (this.currentTab == '1') {
                if (item.resType == '单机') {
                    if (!item.regedit) {
                        this.$msg({
                            showClose: true,
                            message: "暂无资源",
                            type: "warning",
                        });
                        return;
                    }
                    detectProtocol(item.regedit + '://', () => {
                        console.log("未找到协议.");
                        this.$confirm("未检测到软件，立即下载。", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        })
                            .then(() => {
                                if (item.fileId) {
                                    getFileInfo(item.fileId).then(res => {
                                        if (res.code == 200) {
                                            var src = this.$severUrl(res.data.fileUrl);
                                            var link = document.createElement('a');
                                            link.href = src;
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        }
                                    })
                                } else {
                                    this.$msg({
                                        showClose: true,
                                        message: "暂无资源",
                                        type: "warning",
                                    });
                                }
                            })
                            .catch(() => {
                                this.$message({
                                    type: "info",
                                    message: "已取消下载"
                                });
                            });
                    },
                        () => {
                            console.log("找到自定义协议并成功打开文件.");
                        },
                        1000
                    );
                }
                else {
                    window.open(url, '_blank');
                }
            } else if (this.currentTab == '2') {
                if (item.resType == '单机') {
                    if (!item.regedit) {
                        this.$msg({
                            showClose: true,
                            message: "暂无资源",
                            type: "warning",
                        });
                        return;
                    }
                    detectProtocol(item.regedit + '://', () => {
                        console.log("未找到协议.");
                        this.$confirm("未检测到软件，立即下载。", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        })
                            .then(() => {
                                if (item.fileId) {
                                    getFileInfo(item.fileId).then(res => {
                                        if (res.code == 200) {
                                            var src = this.$severUrl(res.data.fileUrl);
                                            var link = document.createElement('a');
                                            link.href = src;
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        }
                                    })
                                } else {
                                    this.$msg({
                                        showClose: true,
                                        message: "暂无资源",
                                        type: "warning",
                                    });
                                }
                            })
                            .catch(() => {
                                this.$message({
                                    type: "info",
                                    message: "已取消下载"
                                });
                            });
                    },
                        () => {
                            console.log("找到自定义协议并成功打开文件.");
                        },
                        1000
                    );
                } else {
                    PushExamineRecord(params).then(res => {
                        if (res.code == 200) {
                            sessionStorage.setItem('businessId', this.taskId + '-' + item.id);
                            let href = window.location.origin + `/virtualTest?url=${item.url}&optSource=${this.optSource}&businessId=${this.taskId + '-' + item.id}`;
                            window.open(href, '_blank');
                        }
                    })
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
.soft-box {
    height: 50rem;
    overflow: auto;
}

.btn-button {
    width: 72px;
    height: 26px;
    background: var(--blue);
    border-radius: 0.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    cursor: pointer;
}

.disable-button {
    cursor: not-allowed !important;
    background-color: #C0C4CC !important;
}

/deep/.el-dialog {
    border-radius: 1rem;
}

/deep/.el-dialog__header {
    font-weight: 700;
    padding: 3rem 5rem;
}

/deep/.el-dialog__body {
    padding: 0 3rem 5rem 3rem;
}
</style>